// extracted by mini-css-extract-plugin
export default {"table":"root_table-module__table___LfsFJ","extendedTable":"root_table-module__extendedTable___RRkKo"};